import styled from 'styled-components';
import { DialogActions as MuiDialogActions, DialogTitle as MuiDialogTitle, DialogContent as MuiDialogContent } from '@material-ui/core';

interface IDialogTitle {
  color?: string;
}
export const DialogTitle = styled(MuiDialogTitle) <IDialogTitle>`
  margin-bottom: 16px;
  &.MuiDialogTitle-root {
    padding: 0;
    & .MuiTypography-h6{
      font-size: 1.8rem;
      color: var(--grayLv3);
    }
  }
  color: ${({color = 'red'}) => `var(--color-${color})`};
`;

export const DialogContent = styled(MuiDialogContent)`
  /* margin-top: 20px; */
  &.MuiDialogContent-root {
    padding: 8px 0;
  }
`;

export const DialogText = styled.p`
  font-size: 1.6rem;
  color: var(--grayLv3);
`;

export const DialogActions = styled(MuiDialogActions)`
  width: 100%;
  margin-top: 32px;
  @media(min-width: 1280px) {
    /* margin-top: 40px; */
  }
  
  &.MuiDialogActions-root {
    padding: 0;
    justify-content: flex-end;
  }
`;
